module.exports = __webpack_public_path__ + "img/lock-locked.567090b7.svg";